<template>
    <div class="property-select" :class="!showComponents ? 'property-select-opacity' : ''" v-if="currentComponent">
        <h3 class="font-weight-bold">
            {{ $t('contrato_rastreabilidade.messages.report_properties.title') }}
        </h3>
        <el-card>
            <p>
                {{ $t('contrato_rastreabilidade.messages.report_properties.subtitle') }}.
            </p>
            <component
                v-model="form.properties"
                :is="currentComponent"
                ref="propertySelectComponent"
            />
        </el-card>
    </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
    name: 'PropertySelect',
    data() {
        return {
            components: {
                'PY': () => import('@/modules/traceability-contract/views/components/property-select/py.vue')
            }
        };
    },
    computed: {
        ...mapState('traceabilityContractModule', ['form']),
        currentComponent() {
            this.$emit('input', {});
            const user = this.$store.state.usuarioLogado;
            return this.components[user.paisGrupo];
        },
        showComponents() {
            return !!this.form.protocol_id;
        }
    }
};
</script>

<style scoped lang="scss">
h3 {
    margin: 16px 0;
    color: #3B3B3B;
    font-weight: 500;
    font-size: 16px;
}
.property-select-opacity {
    opacity: 0.5;
}
</style>
